import React, {useState, useEffect} from 'react'

import classes from './CatalogueItem.module.css'
import PlayAudio from '@/components/shared/PlayAudio/PlayAudio';

import Button from '@/components/shared/Button/Button';
import { FaPlay, FaVolumeHigh } from 'react-icons/fa6';
import { PlayAudioBtn } from '@/components/shared/PlayAudio/PlayAudio';

const CatalogueItem = ({item, autoplayAudio = false}) => {

  return (
    <div className={classes.CatalogueItem}>
      <div className={classes.image}>
        <img src={item.image} alt="" />
      </div>
      <div className={classes.infos}>
        <div className={classes.title_cntr}>
          {item.Audio &&
          <PlayAudio audio={item.Audio} autoplay={autoplayAudio}>
            {PlayAudioBtn}
            {/* {(playing, handleClick) => <div onClick={handleClick}>{playing ? "STOP" : "PLAY" }</div>} */}
          </PlayAudio>}
          <div className={classes.title}>
            {item.titre}
          </div>
        </div>
        <div className={classes.description}>
          {item.description}

        </div>
      </div>
    </div>
  );
};

export default CatalogueItem;
